import { ApiResponse } from 'apisauce'
import { call, put } from 'redux-saga/effects'
import { Buffer } from 'buffer'

import api from 'src/services/api'
import i18n from 'src/config/i18n'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'

import * as MeActions from '../me/actions'
import * as AuthActions from './actions'
import { RecoverPasswordType } from './types'

export function* authByQRCode({
  payload: { user_key }
}: ReturnType<typeof AuthActions.authByQRCode>) {
  try {
    const { data, ok } = yield call(api.post, 'auth/qrcode', null, {
      headers: { user_key }
    })

    if (ok) {
      yield put(AuthActions.authSuccess(data))
      yield put(MeActions.getMe())
      return
    }

    yield put(AuthActions.authFailure())
  } catch (err) {
    yield put(AuthActions.authFailure())
  }
}

export function* authByUsername({
  payload: { password, username }
}: ReturnType<typeof AuthActions.authByUsername>) {
  try {
    const { data, ok } = yield call(api.post, 'auth/login', null, {
      headers: {
        Authorization: `Basic ${Buffer.from(`${username}:${password}`).toString(
          'base64'
        )}`
      }
    })

    if (ok) {
      yield put(AuthActions.authSuccess(data))
      yield put(MeActions.getMe())
      return
    }

    yield put(AuthActions.authFailure())
  } catch (err) {
    yield put(AuthActions.authFailure())
  }
}

export function* authForgotPassword({
  payload: { username }
}: ReturnType<typeof AuthActions.authForgotPassword>) {
  try {
    const response: ApiResponse<RecoverPasswordType> = yield call(
      api.post,
      `/auth/recover-password`,
      {
        username
      }
    )

    if (response.ok) {
      const message = i18n.t('web.login.forgot-password-success')
      yield put(AuthActions.authForgotPasswordSuccess(message))
      return
    }

    if (response.status === 400) {
      if (response.data.message === 'The given login is invalid!') {
        const message = i18n.t('web.login.login-is-invalid')
        yield put(AuthActions.authForgotPasswordFailure(message))
        return
      }

      if (
        response.data.message === 'Error trying to send the folowing e-mails!'
      ) {
        const message = i18n.t('web.login.error-to-send-email')
        yield put(AuthActions.authForgotPasswordFailure(message))
        return
      }

      if (response.data.message === 'The user has no registered email!') {
        const message = i18n.t('web.login.user-has-no-email')
        yield put(AuthActions.authForgotPasswordFailure(message))
        return
      }
    }

    const message = findBasicApiResponseErrors(response)
    yield put(AuthActions.authForgotPasswordFailure(message))
  } catch (err) {
    const message = i18n.t('common.response.unexpected-error')
    yield put(AuthActions.authForgotPasswordFailure(message))
  }
}
